import {
  GenderEnum,
  ServiceTypeEnum,
  SpaceTypeEnum,
} from 'src/common/external/bambi-api/bambiApi';

import { AddTripFormValues } from './FormValues';

export const defaultFormValues: AddTripFormValues = {
  id: '',
  booked_by_name: '',
  booked_by_phone_number: '',
  booked_by_phone_extension: '',
  passenger: {
    id: '',
    first_name: '',
    last_name: '',
    dob: '',
    gender: '' as GenderEnum,
    weight: 0,
    needs_bariatric_transport: false,
    is_student: false,
    phone_number: '',
    email: '',
    notes: '',
    organization_id: '',
    created_at: '',
    updated_at: '',
    full_name: '',
    payer_ids: [],
    has_tilled_account: false,
  },
  trips: [
    {
      pickupLocation: {
        address: { label: '', value: '' },
        address_details: '',
        stairs: 0,
        stair_equipment: undefined,
        contact_name: '',
        contact_phone_number: '',
        driver_notes: '',
      },
      dropoffLocation: {
        address: { label: '', value: '' },
        address_details: '',
        stairs: 0,
        stair_equipment: undefined,
        contact_name: '',
        contact_phone_number: '',
        driver_notes: '',
      },
      timing: {
        date: '',
        appointment_time: '',
        pickup_time: '',
        is_will_call: false,
      },
      dispatcher_notes: '',
      external_trip_id: '',
      input_price_cents: null,
      is_price_locked: false,
      load_time_seconds: 0,
      unload_time_seconds: 0,
      is_wait_and_return_outbound: false,
      is_wait_and_return_inbound: false,
      trip_tags: [],
    },
  ],
  is_round_trip: false,
  service_details: {
    space_type: 'wheelchair' as SpaceTypeEnum,
    service_type: 'curb-to-curb' as ServiceTypeEnum,
    is_oxygen_required: false,
    oxygen_liters_per_min: '0',
    num_attendants_needed: 0,
    num_accompanying_passengers: 0,
    has_infectious_disease: false,
    should_avoid_multiload: false,
  },
  pricing: {
    payer: undefined,
    trip_id: undefined,
    authorization_id: undefined,
    insurance_policy_id: undefined,
    payment_method: undefined,
    payer_passenger_external_id: undefined,
  },
  should_link_passenger_to_payer: false,
  must_provide_wheelchair: false,
  seat_equipment: '',
};
